//#region Styles
import { ContainerParts } from "components/styles";
//#endregion
//#region Components
import ResumeStep1 from "./components/ResumeStep1/ResumeStep1";
import ResumeStep2 from "./components/ResumeStep2/ResumeStep2";
//#endregion

const EventDetail = ({
	dataRelatedToForm: {
		eventTypes,
		eventSubtypes,
		eventGraphics,
		allDays,
		organizers,
		teacherAccounts,
		locations,
		inscriptionEventTypes,
		allCampus,
		campusEnvironments,
		modalities,
		complementaryServiceAreas,
		extracurricularSections,
	},
	eventResumeData,
	toStep,
	cannotUpdate,
}) => {
	return (
		<ContainerParts>
			{eventResumeData && (
				<>
					<ResumeStep1
						data={eventResumeData?.step1}
						eventTypes={eventTypes}
						eventSubtypes={eventSubtypes}
						eventGraphics={eventGraphics}
						complementaryServiceAreas={complementaryServiceAreas}
						allDays={allDays}
						toStep={cannotUpdate ? null : () => toStep(1)}
						cannotUpdate={cannotUpdate}
						extracurricularSections={extracurricularSections}
					/>
					<ResumeStep2
						data={eventResumeData?.step2}
						eventTypeId={eventResumeData?.step1?.eventTypeId}
						organizers={organizers}
						teacherAccounts={teacherAccounts}
						locations={locations}
						inscriptionEventTypes={inscriptionEventTypes}
						allCampus={allCampus}
						campusEnvironments={campusEnvironments}
						modalities={modalities}
						toStep={cannotUpdate ? null : () => toStep(2)}
						cannotUpdate={cannotUpdate}
					/>
				</>
			)}
		</ContainerParts>
	);
};

export default EventDetail;
